import { Injectable } from '@angular/core';
import { EstruturaPermissoesAcessoResult } from '../Results/EstruturaPermissoesAcessoResult';
import { ETelaSistema } from '../Enums/ETelaSistema';
import { EMenuSistema } from '../Enums/EMenuSistema';
import { ETelaSistemaConfiguracao } from '../Enums/ETelaSistemaConfiguracao';

@Injectable({
  providedIn: 'root',
})
export class PermissoesAcessoServices {
  private errosLogados = new Set<string>();

  getPermissoesAcessoFromSession(): EstruturaPermissoesAcessoResult | null {
    const permissoesAcesso = sessionStorage.getItem('permissoesAcesso');
  if (permissoesAcesso) {
    try {
      return JSON.parse(permissoesAcesso) as EstruturaPermissoesAcessoResult;
    } catch (error) {
      console.error('Erro ao converter permissoesAcesso:', error);
    }
  }
  return null;
  }

  getPermissoesAcessoTelaFromSession(menu: EMenuSistema, tela: ETelaSistema | ETelaSistemaConfiguracao): boolean[] {
    try {
      const permissoesAcesso = this.getPermissoesAcessoFromSession();

      if (permissoesAcesso == null) {
        return [false, false, false, false];
      }

      const permissaoTela = permissoesAcesso.Menu.filter(item => item.descricao == menu)[0]
        .SubMenu.filter(item => item.descricao == tela)[0];

      return [permissaoTela.consultar, permissaoTela.cadastrar, permissaoTela.editar, permissaoTela.deletar];
    } catch (error) {
      const chave = `${menu}:${tela}`;
      if (!this.errosLogados.has(chave)) {
        this.errosLogados.add(chave);
        console.error('Erro ao obter permissões de acesso da tela:', error, { menu, tela });
      }
      return [false, false, false, false];
    }
  }
}
